import * as React from "react";
const Website = props => <symbol viewBox="0 0 24 24" {...props}>
    <g>
      <path d="M19.658 3.25H4.342A2.094 2.094 0 002.25 5.342v13.316a2.094 2.094 0 002.092 2.092h15.316a2.094 2.094 0 002.092-2.092V5.342a2.094 2.094 0 00-2.092-2.092zM4.342 4.75h15.316a.592.592 0 01.592.592V9.25H3.75V5.342a.593.593 0 01.592-.592zm15.316 14.5H4.342a.593.593 0 01-.592-.592V10.75h16.5v7.908a.593.593 0 01-.592.592z" />
      <path d="M6 8a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2z" />
    </g>
  </symbol>;
export default Website;